import axios from 'axios';

const ACTION_APPEND = 'append';
const ACTION_REPLACE = 'replace';

export const MultiListFeed = {
  state: {
    loading: false,
    cases: {
      items: [],
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0,
        last_page: 0,
      },
    },
    collections: {
      items: [],
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0,
        last_page: 0,
      },
    },
    users: {
      items: [],
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0,
        last_page: 0,
      },
    },
  },
  getters: {
    getList: (state) => (parameter) => {
      return state[parameter];
    },
    getBusyList: (state) => () => {
      return state.loading;
    },
  },
  mutations: {
    setList(state, { items, type }) {
      state[type].items.push(...items);
    },
    replaceList(state, { items, type }) {
      state[type].items = items;
    },
    setFeedPagination(state, { pagination, type }) {
      state[type].pagination = {
        ...state.pagination,
        current_page: pagination.current_page,
        per_page: pagination.per_page,
        total: pagination.total,
        last_page: pagination.last_page,
      };
    },
    removeItem(state, { type, id }) {
      state[type].items = state[type].items.filter((item) => item.id !== id);
    },
    setBusyList(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async requestFeed({ state, commit }, { page = null, action = ACTION_APPEND, fetchUrl, type }) {
      if (state[type].pagination.current_page !== state[type].pagination.last_page || action === ACTION_REPLACE) {
        if (page !== null) {
          commit('setCurrentPage', page);
        }

        commit('setBusyList', true);
        commit('replaceList', { items: [], type: type });

        try {
          let response = await axios.get(fetchUrl.url, fetchUrl.params);

          if (action === ACTION_APPEND) {
            commit('setList', { items: response.data.data, type: type });
          }

          if (action === ACTION_REPLACE) {
            commit('replaceList', { items: response.data.data, type: type });
          }

          commit('setFeedPagination', { pagination: response.data.meta, type: type });
          commit('setBusyList', false);
        } catch (err) {
          console.error(err);
        }
      }
    },

    removeListItem({ state, commit }, { type, id }) {
      commit('removeItem', { type: type, id: id });

      const total = state[type].pagination.total - 1;
      const lastPage = Math.ceil(total / state[type].pagination.per_page);
      const currentPage =
        lastPage <= state[type].pagination.current_page ? lastPage : state[type].pagination.current_page;
      const updatedPagination = {
        ...state[type].pagination,
        total: total,
        last_page: lastPage,
        current_page: currentPage,
      };

      commit('setFeedPagination', { pagination: updatedPagination, type: type });
    },
  },
};
